<template>
  <QDrawer
    :model-value="true"
    :mini="!configStore.rightDrawerOpen"
    side="right"
    persistent
    no-swipe-open
    no-swipe-close
    no-swipe-backdrop
    :width="250"
    :mini-width="0"
    :behavior="'desktop'"
    :overlay="$q.screen.lt.md"
    class="right-drawer"
  >
    <QIcon
      v-if="$q.screen.gt.sm"
      name="shopping_cart"
      class="right-drawer-toggle"
      @click="configStore.toggleRightDrawer()"
    />
    <QScrollArea
      class="h-full w-full"
      :content-style="{width:'100%'}"
    >
      <PregameCart v-if="$route.name.includes('pregames') || $route.name.includes('prematches')" />
      <LiveCart v-else-if="$route.name.includes('lives')" />
      <MiniGameCart v-else-if="$route.name.includes('mini-games')" />
      <VirtualGameCart v-else-if="$route.name.includes('virtual-games')" />
      <DuotoneBallCart v-else-if="$route.name.includes('duotone-balls')" />
      <Cart v-else />
      <div class="mt-2 flex flex-col gap-2">
        <Telegram />
        <!--              <KakaoTalk />-->
        <ForeverDomain />
      </div>
    </QScrollArea>
  </QDrawer>
</template>

<script setup>
import PregameCart from '@/components/Carts/PregameCart.vue'
import LiveCart from '@/components/Carts/LiveCart.vue'
import MiniGameCart from '@/components/Carts/MiniGameCart.vue'
import VirtualGameCart from '@/components/Carts/VirtualGameCart.vue'
import DuotoneBallCart from '@/components/Carts/DuotoneBallCart.vue'
import Cart from '@/components/Carts/Cart.vue'
import Telegram from '@/components/Decals/Telegram.vue'
import KakaoTalk from '@/components/Decals/KakaoTalk.vue'
import ForeverDomain from '@/components/Decals/ForeverDomain.vue'
import { useConfigStore } from '@/stores/config.js'
import { whenever } from '@vueuse/core'
import { useQuasar } from 'quasar'

const $q = useQuasar()
const configStore = useConfigStore()

whenever(() => $q.screen.lt.md, () => {
  configStore.rightDrawerOpen = false
}, { immediate: true })
whenever(() => $q.screen.gt.md, () => {
  configStore.rightDrawerOpen = true
}, { immediate: true })

</script>
